import { Grid, Typography } from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import { ButtonCard } from "common/components/ButtonCard";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toggleAllMetersAction } from "../meter.actions";
import { IMeterObject } from "../types";
import { TwoFactorStepper } from "./2Factor/twoFactorStepper";
import { AlertDialog } from "../../common/components/AlertDialog";

interface IMeterToggleProps {
  meters: IMeterObject[];
  monitoringOn: boolean;
  domainCode: string;
  phoneNumbers: string[] | null;
}

export const MeterToggleSwitch = ({
  meters,
  monitoringOn,
  domainCode,
  phoneNumbers,
}: IMeterToggleProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [twoFactorOpened, setTwoFactorOpened] = useState<boolean>(false);
  const [alertDialogOpened, setalertDialogOpened] = useState<boolean>(false);

  const shouldOpenAlert = meters.some((m) => m.Status === true);
  const handleChange = (checked: boolean) => {
    if (!phoneNumbers || phoneNumbers.length < 1) {
      setTwoFactorOpened(true);
      return;
    }
    if (!checked) {
      dispatch(toggleAllMetersAction(domainCode, checked));
      return;
    } else if (checked && shouldOpenAlert) {
      setalertDialogOpened(true);
    } else {
      dispatch(toggleAllMetersAction(domainCode, checked));
    }
  };

  const handleTwoFactorClose = (success?: boolean) => {
    if (success === true) {
      shouldOpenAlert
        ? setalertDialogOpened(true)
        : dispatch(toggleAllMetersAction(domainCode, true));
      setTwoFactorOpened(false);
    }
    setTwoFactorOpened(false);
  };

  const alertClose = (activatecallback: boolean) => {
    if (activatecallback) dispatch(toggleAllMetersAction(domainCode, true));
    setalertDialogOpened(false);
  };

  return (
    <>
      <ButtonCard fullWidth>
        <Typography variant="h4" color="primary">
          {t("Activate shell protection")}
        </Typography>
        <Switch
          size="small"
          checked={monitoringOn}
          color="secondary"
          onChange={(e) => handleChange(e.target.checked)}
        />
      </ButtonCard>

      <TwoFactorStepper open={twoFactorOpened} onClose={handleTwoFactorClose} />
      <AlertDialog
        open={alertDialogOpened}
        onClose={alertClose}
        activateTitle={t("Activate shell protection")}
        openNodes={meters
          .filter((m) => m.Status)
          .map((m) => `${m.Name} ${t("is open!")}`)}
      />
    </>
  );
};

export default MeterToggleSwitch;
